/**
 * HC Nav Parent Fix
 * Prevents navigation when clicking a top-level menu item that has a submenu.
 * The submenu still opens on hover as normal.
 */
(function () {
  function init() {
    // Desktop header-menu: prevent click navigation on parent items with submenus
    document.querySelectorAll('header-menu .menu-list__link[aria-haspopup="true"]').forEach(function (link) {
      if (link.dataset.hcNavFixed) return;
      link.dataset.hcNavFixed = '1';
      link.addEventListener('click', function (e) {
        e.preventDefault();
      });
    });
  }

  // Run immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run after any Shopify Section/Block re-renders
  document.addEventListener('shopify:section:load', init);
})();
